__turbopack_context__.v({
  "accessory": "ProfileMenu-module-scss-module__bcLdvq__accessory",
  "avatar": "ProfileMenu-module-scss-module__bcLdvq__avatar",
  "avatar-container": "ProfileMenu-module-scss-module__bcLdvq__avatar-container",
  "button": "ProfileMenu-module-scss-module__bcLdvq__button",
  "container": "ProfileMenu-module-scss-module__bcLdvq__container",
  "menu": "ProfileMenu-module-scss-module__bcLdvq__menu",
  "menu-container": "ProfileMenu-module-scss-module__bcLdvq__menu-container",
  "menu-section": "ProfileMenu-module-scss-module__bcLdvq__menu-section",
});
